export default "__VITE_ASSET__BXeAAIgc__"